import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=1f9a2b49&scoped=true&"
import script from "./ExpandButton.vue?vue&type=script&lang=js&"
export * from "./ExpandButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandButton.vue?vue&type=style&index=0&id=1f9a2b49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a2b49",
  null
  
)

export default component.exports